'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _FormInput = require('../FormInput');

var _PaymentOption = require('../PaymentOption');

var _PaymentOption2 = _interopRequireDefault(_PaymentOption);

var _localisedPaths = require('../../helpers/localisedPaths');

var _StoreCredit = require('../PaymentOption/StoreCredit');

var _StoreCredit2 = _interopRequireDefault(_StoreCredit);

var _presentation = require('../../actions/presentation');

var _location = require('../../helpers/location');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentForm = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaymentForm, _React$Component);

  function PaymentForm(props) {
    (0, _classCallCheck3.default)(this, PaymentForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentForm.__proto__ || (0, _getPrototypeOf2.default)(PaymentForm)).call(this, props));

    _this.state = {
      paymentError: '',
      tcChecked: false,
      tcChangeHandler: false
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var t = this.props.t;


      var result = (0, _location.getQueryParam)('result', '');

      switch (result) {
        case '':
          this.setPaymentError();
          break;
        case 'refused':
          this.setPaymentError(t('spree.adyen_cse.gateway_errors.refused'));
          break;
        case 'cancelled':
          this.setPaymentError(t('spree.adyen_cse.gateway_errors.cancelled'));
          break;
        case 'error':
        default:
          this.setPaymentError(t('spree.adyen_cse.gateway_errors.default_refusal_reason'));
          break;
      }
    }
  }, {
    key: 'onPaymentSelect',
    value: function onPaymentSelect(e) {
      this.props.dispatch((0, _presentation.selectPaymentOption)(e.currentTarget.value));
    }
  }, {
    key: 'setTcCheckedChangeHandler',
    value: function setTcCheckedChangeHandler() {
      var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.tcChangeHandler = handler;
    }
  }, {
    key: 'setPaymentError',
    value: function setPaymentError() {
      var paymentError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.setState({ paymentError: paymentError });
    }
  }, {
    key: 'handleTcCheckedChange',
    value: function handleTcCheckedChange(value) {
      this.state.tcChecked = value;

      if (this.state.tcChangeHandler) {
        this.state.tcChangeHandler(value);
      }
    }
  }, {
    key: 'coveredByStoreCredit',
    value: function coveredByStoreCredit() {
      return this.props.order.coveredByStoreCredit;
    }
  }, {
    key: 'availableStoreCredit',
    value: function availableStoreCredit() {
      return this.props.order.displayTotalAvailableStoreCredit;
    }
  }, {
    key: 'storeCreditOption',
    value: function storeCreditOption() {
      if (!this.hasStoreCreditToUse()) return null;

      return _react2.default.createElement(_StoreCredit2.default, { availableStoreCredit: this.availableStoreCredit() });
    }
  }, {
    key: 'hasStoreCreditToUse',
    value: function hasStoreCreditToUse() {
      return this.props.order.totalApplicableStoreCredit > 0;
    }
  }, {
    key: 'availablePaymentMethods',
    value: function availablePaymentMethods() {
      var paymentMethods = this.props.order.paymentMethodsResponse.paymentMethods;

      return paymentMethods;
    }
  }, {
    key: 'insideFieldSet',
    value: function insideFieldSet(content, legend) {
      var extraStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      return _react2.default.createElement(
        _FormInput.Fieldset,
        { extraStyle: extraStyle },
        _react2.default.createElement(
          _FormInput.Legend,
          null,
          legend
        ),
        content
      );
    }
  }, {
    key: 'remainingToPayMessage',
    value: function remainingToPayMessage() {
      if (this.coveredByStoreCredit()) return _react2.default.createElement(
        'p',
        null,
        'Your order is covered by store credits.'
      );
      return _react2.default.createElement(
        'p',
        null,
        'You must pay ',
        this.props.order.displayOrderTotalAfterStoreCredit,
        ' not covered by your available store credit.'
      );
    }
  }, {
    key: 'paymentMethodFor',
    value: function paymentMethodFor(method) {
      var t = this.props.t;


      if (method.methodType === 'adyen_cse') {
        method.name = t('spree.credit_or_debit_card');
      }
      return method;
    }
  }, {
    key: 'renderPaymentOptions',
    value: function renderPaymentOptions() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          order = _props.order,
          params = _props.params,
          setCheckoutFormSubmitter = _props.setCheckoutFormSubmitter;


      var cashPaymentMethods = this.availablePaymentMethods().map(function (paymentMethod, index) {
        return _react2.default.createElement(_PaymentOption2.default, {
          selectable: !_this2.coveredByStoreCredit(),
          paymentMethod: _this2.paymentMethodFor(paymentMethod),
          paymentMethodId: index,
          onPaymentSelect: _this2.onPaymentSelect.bind(_this2),
          active: parseInt(_this2.props.presentation.selectedPaymentOptionId, 10) === index,
          params: params,
          order: order,
          setCheckoutFormSubmitter: setCheckoutFormSubmitter,
          getTcCheckedState: function getTcCheckedState() {
            return _this2.state.tcChecked;
          },
          setTcCheckedChangeHandler: function setTcCheckedChangeHandler(f) {
            return _this2.setTcCheckedChangeHandler(f);
          },
          dispatch: _this2.props.dispatch,
          setPaymentError: function setPaymentError(s) {
            return _this2.setPaymentError(s);
          }
        });
      });

      var storeCreditOption = this.storeCreditOption();
      if (!storeCreditOption) {
        return this.insideFieldSet(_react2.default.createElement(
          'div',
          null,
          cashPaymentMethods,
          this.renderErrors()
        ), t('spree.payment_method'), 'paymentFieldSet');
      }

      return _react2.default.createElement(
        'div',
        null,
        this.insideFieldSet(storeCreditOption, 'Store Credit'),
        this.insideFieldSet(_react2.default.createElement(
          'div',
          null,
          this.remainingToPayMessage(),
          cashPaymentMethods,
          this.renderErrors()
        ), t('spree.payment_method'), 'paymentFieldSet')
      );
    }
  }, {
    key: 'renderErrors',
    value: function renderErrors() {
      return _react2.default.createElement(
        _FormInput.Label,
        { className: 'a-label a-label--error' },
        this.props.flash.payment_error_message || this.state.paymentError || ''
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      var lng = this.props.params.lng;

      return _react2.default.createElement(
        'div',
        null,
        this.renderPaymentOptions(),
        _react2.default.createElement(
          _FormInput.Fieldset,
          null,
          _react2.default.createElement(
            _FormInput.Legend,
            { smallMobile: true },
            t('terms_and_conditions_title')
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'accepted_terms_and_conditions' },
            _react2.default.createElement(_FormInput.Checkbox, {
              id: 'accepted_terms_and_conditions',
              name: 'accepted_terms_and_conditions',
              defaultChecked: false,
              onChange: function onChange(e) {
                return _this3.handleTcCheckedChange(e.target.checked);
              },
              required: true
            }),
            _react2.default.createElement(
              _FormInput.Label,
              {
                htmlFor: 'accepted_terms_and_conditions',
                className: 'a-label--checkbox'
              },
              t('i_have_read_and_understood_the'),
              '\xA0',
              _react2.default.createElement(
                'a',
                {
                  className: 'a-link',
                  href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'termsConditionsPath', lng),
                  target: '_blank',
                  rel: 'noopener noreferrer'
                },
                t('spree.terms_and_conditions.link_text')
              )
            )
          )
        )
      );
    }
  }]);
  return PaymentForm;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object,
  flash: _react.PropTypes.object,
  presentation: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object,
  setCheckoutFormSubmitter: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PaymentForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentForm/index.js
// module id = 2301
// module chunks = 0